import { string, shape, bool, array } from "prop-types";
import { getLink } from "@lib/getLink";
import { LinkableArea } from "./LinkableArea";

export const Footer = ({ styles, caption, ctaTitle, ctaLink }) => {
  const formattedCtaLink = ctaLink ? getLink(ctaLink) : {};

  return (
    <div className={styles}>
      {caption && <figcaption>{caption}</figcaption>}
      {ctaTitle && (
        <LinkableArea
          rawLink={ctaLink}
          formattedLink={formattedCtaLink}
        >
          <p>{ctaTitle}</p>
        </LinkableArea>
      )}
    </div>
  )
}

Footer.propTypes = {
  styles: string,
  caption: string,
  ctaTitle: string,
  ctaLink: shape({
    refTitle: string,
    type: string,
    handle: string,
    link: shape({
      _type: string,
      blank: bool,
      href: string
    }),
    slug: shape({
      _type: string,
      current: string
    }),
    productGroup: array,
  })
};